import { useMemo } from 'react';

export const useClinicConfigMap = (clinicConfig: any[]) => {
  return useMemo(() => {
    const map = new Map<string, string>();
    if (Array.isArray(clinicConfig)) {
      for (const config of clinicConfig) {
        map.set(`${config.groupName}:${config.codeName}`, config.codeValue);
      }
    }
    return map;
  }, [clinicConfig]);
};
